module.exports = __webpack_public_path__ + "static/media/top_infographic_desktop.4dbc5fb0.webp";